import React from "react";
import { PiCheck } from "react-icons/pi";
import { Link } from "react-router-dom";

import { useGetCreditsAvailable } from "../../../api/payments";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import noContentImg from "../../../images/no-content.svg";

function NoCertificates() {
  const { data: creditsAvailable } = useGetCreditsAvailable();

  if (!creditsAvailable) {
    return <LoadingSpinner />;
  }
  return (
    <div className="d-flex flex-column align-items-center justify-content-center">
      <img src={noContentImg} alt="no certificates" className="mb-4" />
      <p style={{ width: "16rem" }} className="mx-auto fw-bold text-center mb-4">
        You currently don&apos;t have any USMCA certificates.
      </p>
      <div className="d-flex align-items-center justify-content-center gap-2">
        {creditsAvailable.certCredits > 0 ? (
          <Link to="/dashboard/certificate-of-origin/generate/" className="btn btn-primary text-uppercase fw-bold">
            Create one
          </Link>
        ) : (
          <a
            target="_blank"
            href={`${import.meta.env.VITE_MAIN_SITE_URL}/dashboard/upgrade/usmca-certification`}
            className="btn btn-primary text-uppercase fw-bold"
            rel="noreferrer"
          >
            Purchase credits
          </a>
        )}

        <Link to="/dashboard/" className="btn text-uppercase fw-bold d-flex gap-1 align-items-center">
          <PiCheck />
          Qualification History
        </Link>
      </div>
    </div>
  );
}

export default NoCertificates;
